import smoothScroll from './smoothScroll';
import toggleSlideContents from './toggleSlideContents';
import executeSlider from './executeSlider';

smoothScroll();
toggleSlideContents();
executeSlider();
